/* GermanyKG Telefon-Login – passwortlos (nur Einmal-Code).
   Einstieg über die Handynummer → bekannt: Login-Code; neu: Registrierung (Name,
   Geburtsdatum, Geschlecht) + Code. Spricht mit dem Dienst über /apps/konto/api/*. */
(function () {
  'use strict';

  var API = '/apps/konto/api';
  var SESSION_KEY = 'gkg_session';

  var T = {
    login: 'Войти / Зарегистрироваться', register: 'Регистрация', account: 'Мой аккаунт', logout: 'Выйти',
    phone: 'Номер телефона', continue: 'Получить код',
    firstName: 'Имя', lastName: 'Фамилия', birthDate: 'Дата рождения', gender: 'Пол',
    male: 'Мужской', female: 'Женский',
    getCodeWa: 'Получить код в WhatsApp', getCodeSms: 'Получить код по SMS',
    code: 'Код из сообщения', confirm: 'Подтвердить',
    resendIn: 'Отправить код повторно можно через', resend: 'Отправить код повторно',
    tryOtherChannel: 'Отправить другим способом', sec: 'сек.',
    codeSentWa: 'Мы отправили код в WhatsApp.', codeSentSms: 'Мы отправили код по SMS.',
    notRegistered: 'Этот номер ещё не зарегистрирован. Заполните, пожалуйста, данные ниже.',
    dataNote: 'Эти данные нужны, чтобы надёжно восстановить ваш аккаунт и сохранить бонусные баллы.',
    createAccount: 'Зарегистрироваться', enterCode: 'Введите код',
    welcome: 'Здравствуйте', yourPhone: 'Ваш номер', loyaltyPoints: 'Бонусные баллы',
    accountDetails: 'Данные аккаунта', orderHistory: 'История покупок',
    ordersSoon: 'Здесь появится история ваших покупок.', ordersLoading: 'Загружаем историю покупок…', ordersEmpty: 'Здесь пока нет покупок.', sizeShort: 'разм.', returned: 'Возврат', nameLabel: 'Имя',
    myPurchases: 'Мои покупки', myData: 'Мои данные', favsTile: 'Избранное',
    seeAll: 'Смотреть все', favsEmptyAcc: 'Вы пока ничего не добавили в избранное.',
    supportBtn: 'Связаться с нами', supportMsg: 'Здравствуйте! Мне нужна помощь.',
    edit: 'Редактировать', save: 'Сохранить', cancel: 'Отмена',
    firstName: 'Имя', lastName: 'Фамилия', saved: 'Данные сохранены.',
    bonusHint: 'Начисляются за покупки в наших магазинах',
    birthLabel: 'Дата рождения', genderLabel: 'Пол', genderMale: 'Мужской', genderFemale: 'Женский',
    subtitle: 'Введите номер телефона — вход и регистрация в одном месте.',
    selectGender: 'Выберите пол',
    otherCode: 'Другой код…', countryCode: 'Код страны',
    smsKgOnlyNote: 'SMS доступна только для номеров +996. Для других номеров код придёт в WhatsApp.'
  };
  var ERR = {
    invalid_phone: 'Неверный номер телефона.',
    invalid_channel: 'Этот способ сейчас недоступен.',
    invalid_request: 'Что-то пошло не так. Начните заново.',
    already_registered: 'Этот номер уже зарегистрирован. Войдите.',
    not_registered: 'Этот номер не зарегистрирован.',
    rate_limited: 'Слишком много запросов. Попробуйте позже.',
    send_failed_try_other_channel: 'Не удалось отправить. Попробуйте другой способ.',
    code_invalid: 'Неверный код.', code_expired: 'Срок действия кода истёк. Запросите новый код.',
    too_many_attempts: 'Слишком много попыток. Запросите новый код.',
    invalid_name: 'Укажите имя и фамилию.',
    invalid_birth_date: 'Укажите корректную дату рождения.',
    invalid_gender: 'Выберите пол.',
    unauthorized: 'Сессия истекла. Войдите снова.',
    sms_kg_only: 'SMS доступна только для номеров +996. Выберите WhatsApp.',
    default: 'Что-то пошло не так. Попробуйте ещё раз.'
  };
  function errText(c) { return ERR[c] || ERR.default; }

  // Länder-Vorwahlen: +996 zuerst (Standard). Weitere für Diaspora/Nachbarländer.
  // SMS bleibt +996-only (siehe channelButtons); WhatsApp geht mit jeder Vorwahl.
  var COUNTRIES = [
    { dial: '996', name: 'Кыргызстан', flag: '🇰🇬', len: 9, ph: '700123456' },
    { dial: '7',   name: 'Россия / Казахстан', flag: '🇷🇺', ph: '9001234567' },
    { dial: '998', name: 'Узбекистан', flag: '🇺🇿', ph: '901234567' },
    { dial: '992', name: 'Таджикистан', flag: '🇹🇯', ph: '901234567' },
    { dial: '993', name: 'Туркменистан', flag: '🇹🇲', ph: '61234567' },
    { dial: '90',  name: 'Турция', flag: '🇹🇷', ph: '5321234567' },
    { dial: '86',  name: 'Китай', flag: '🇨🇳', ph: '13123456789' },
    { dial: '971', name: 'ОАЭ', flag: '🇦🇪', ph: '501234567' },
    { dial: '49',  name: 'Германия', flag: '🇩🇪', ph: '15112345678' },
    { dial: '1',   name: 'США / Канада', flag: '🇺🇸', ph: '2015550123' }
  ];

  function getSession() { try { return localStorage.getItem(SESSION_KEY) || ''; } catch (e) { return ''; } }
  function setSession(t) { try { localStorage.setItem(SESSION_KEY, t); } catch (e) {} }
  function clearSession() { try { localStorage.removeItem(SESSION_KEY); } catch (e) {} }

  function api(path, opts) {
    opts = opts || {};
    var headers = { 'Content-Type': 'application/json' };
    if (opts.auth) { var s = getSession(); if (s) headers['Authorization'] = 'Bearer ' + s; }
    return fetch(API + path, { method: opts.method || (opts.body ? 'POST' : 'GET'), headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, json: j || {} }; }); })
      .catch(function () { return { status: 0, json: { ok: false, error: 'default' } }; });
  }

  function digits(s) { return (s || '').replace(/\D/g, ''); }

  function el(tag, attrs, children) {
    var e = document.createElement(tag); attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'text') e.textContent = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }

  function GkgAuth(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'login';
    this.urls = {
      login: root.getAttribute('data-login-url') || '/pages/konto-login',
      account: root.getAttribute('data-account-url') || '/pages/konto'
    };
    this.smsEnabled = root.getAttribute('data-sms-enabled') === 'true';
    this.state = {};
    this.render();
  }
  GkgAuth.prototype.go = function (u) { window.location.href = u; };
  GkgAuth.prototype.busy = function (on) {
    this.root.classList.toggle('gkg-busy', !!on);
    var b = this.root.querySelectorAll('button'); for (var i = 0; i < b.length; i++) b[i].disabled = !!on;
  };
  GkgAuth.prototype.msg = function (text, type) {
    var box = this.root.querySelector('.gkg-msg'); if (!box) return;
    box.textContent = text || ''; box.className = 'gkg-msg' + (text ? ' gkg-msg--' + (type || 'error') : '');
  };
  GkgAuth.prototype.card = function (title, nodes, footer) {
    this.root.innerHTML = '';
    var body = el('div', { class: 'gkg-card' }, [el('h1', { class: 'gkg-title', text: title }), el('div', { class: 'gkg-msg' })].concat(nodes || []));
    if (footer) body.appendChild(el('div', { class: 'gkg-foot' }, footer));
    this.root.appendChild(body);
  };
  GkgAuth.prototype.labeled = function (label, field) {
    return el('label', { class: 'gkg-field' }, [el('span', { class: 'gkg-label', text: label }), field]);
  };
  GkgAuth.prototype.phoneField = function () {
    var self = this;
    var sel = el('select', { class: 'gkg-input gkg-prefix-sel', 'aria-label': T.countryCode });
    COUNTRIES.forEach(function (c) { sel.appendChild(el('option', { value: c.dial, text: (c.flag ? c.flag + '  ' : '') + '+' + c.dial })); });
    sel.appendChild(el('option', { value: 'other', text: T.otherCode }));
    sel.value = '996';

    // Freies Vorwahl-Feld nur bei „Другой код"
    var dial = el('input', { class: 'gkg-input gkg-input--dial', type: 'tel', inputmode: 'numeric',
      maxlength: '4', placeholder: '+', 'aria-label': T.countryCode });
    dial.hidden = true;
    var input = el('input', { class: 'gkg-input gkg-input--phone', type: 'tel', inputmode: 'numeric',
      autocomplete: 'tel-national', maxlength: '9', placeholder: '700123456' });

    function currentDial() { return sel.value === 'other' ? digits(dial.value) : sel.value; }
    function applyMask() {
      var d = currentDial();
      dial.hidden = sel.value !== 'other';
      input.maxLength = (d === '996') ? 9 : 14;
      var c = null; for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i].dial === d) c = COUNTRIES[i];
      input.placeholder = c ? c.ph : '';
      input.value = digits(input.value).slice(0, input.maxLength);
    }
    sel.addEventListener('change', function () { applyMask(); (dial.hidden ? input : dial).focus(); });
    dial.addEventListener('input', function () { dial.value = digits(dial.value).slice(0, 4); applyMask(); });
    input.addEventListener('input', function () { input.value = digits(input.value).slice(0, input.maxLength); });
    applyMask();

    var wrap = el('div', { class: 'gkg-phone' }, [sel, dial, input]);
    wrap._get = function () {
      var d = currentDial(), sub = digits(input.value);
      if (!d || !sub) return null;
      var full = '+' + d + sub;
      var isKG = (d === '996' && /^\d{9}$/.test(sub));
      // KG: genau 9 Teilnehmerziffern; andere Vorwahlen: allgemeines E.164.
      var valid = (d === '996') ? isKG : /^\+[1-9]\d{7,14}$/.test(full);
      return { full: full, isKG: isKG, valid: valid };
    };
    return wrap;
  };
  GkgAuth.prototype.channelButtons = function (onPick) {
    var self = this, nodes = [el('button', { class: 'gkg-btn gkg-btn--wa', type: 'button', onclick: function () { onPick('whatsapp'); } }, [T.getCodeWa])];
    // SMS nur für kirgisische Nummern anbieten; für andere Vorwahlen bleibt WhatsApp.
    if (self.smsEnabled && self.state.isKG) nodes.push(el('button', { class: 'gkg-btn gkg-btn--sms', type: 'button', onclick: function () { onPick('sms'); } }, [T.getCodeSms]));
    var box = el('div', { class: 'gkg-channels' }, nodes);
    if (self.smsEnabled && !self.state.isKG) box.appendChild(el('p', { class: 'gkg-note gkg-note--muted', text: T.smsKgOnlyNote }));
    return box;
  };

  GkgAuth.prototype.render = function () {
    if (this.mode === 'account') return this.renderAccount();
    return this.renderEntry();
  };

  // ---- Schritt 1: Nummer eingeben ----
  GkgAuth.prototype.renderEntry = function () {
    var self = this; self.state = {};
    var phone = self.phoneField();
    var submit = el('button', { class: 'gkg-btn', type: 'button', onclick: function () {
      self.msg('');
      var v = phone._get();
      if (!v || !v.valid) return self.msg(ERR.invalid_phone);
      self.state.phone = v.full; self.state.isKG = v.isKG;
      self.busy(true);
      api('/auth/start', { body: { phone: self.state.phone } }).then(function (r) {
        self.busy(false);
        if (!r.json.ok) return self.msg(errText(r.json.error));
        if (r.json.registered) self.showChannel('login');
        else self.showRegisterForm();
      });
    } }, [T.continue]);
    var form = el('form', { onsubmit: function (e) { e.preventDefault(); submit.click(); } },
      [el('p', { class: 'gkg-hint', text: T.subtitle }), self.labeled(T.phone, phone), submit]);
    self.card(T.login, [form]);
  };

  // ---- Login-Zweig: Kanal wählen ----
  GkgAuth.prototype.showChannel = function (purpose) {
    var self = this; self.state.purpose = purpose;
    var channels = self.channelButtons(function (ch) { self.requestCode(ch); });
    self.card(T.login, [el('p', { class: 'gkg-hint', text: self.state.phone }), channels],
      [el('button', { class: 'gkg-link', type: 'button', onclick: function () { self.renderEntry(); } }, ['← ' + T.phone])]);
  };

  // ---- Registrierungs-Zweig: Daten + Kanal ----
  GkgAuth.prototype.showRegisterForm = function () {
    var self = this; self.state.purpose = 'register';
    var fn = el('input', { class: 'gkg-input', type: 'text', autocomplete: 'given-name', placeholder: T.firstName });
    var ln = el('input', { class: 'gkg-input', type: 'text', autocomplete: 'family-name', placeholder: T.lastName });
    var bd = el('input', { class: 'gkg-input', type: 'date', max: new Date().toISOString().slice(0, 10) });
    var gender = { value: '' };
    function genderBtn(val, label) {
      return el('button', { class: 'gkg-seg', type: 'button', onclick: function () {
        gender.value = val;
        var all = self.root.querySelectorAll('.gkg-seg'); for (var i = 0; i < all.length; i++) all[i].classList.remove('gkg-seg--on');
        this.classList.add('gkg-seg--on');
      } }, [label]);
    }
    var genderRow = el('div', { class: 'gkg-seg-row' }, [genderBtn('MALE', T.male), genderBtn('FEMALE', T.female)]);

    var channels = self.channelButtons(function (ch) {
      self.msg('');
      if (!fn.value.trim() || !ln.value.trim()) return self.msg(ERR.invalid_name);
      if (!bd.value) return self.msg(ERR.invalid_birth_date);
      if (!gender.value) return self.msg(ERR.invalid_gender);
      self.state.regData = { first_name: fn.value.trim(), last_name: ln.value.trim(), birth_date: bd.value, gender: gender.value };
      self.requestCode(ch);
    });

    self.card(T.register, [
      el('p', { class: 'gkg-note', text: T.notRegistered }),
      self.labeled(T.firstName, fn), self.labeled(T.lastName, ln), self.labeled(T.birthDate, bd),
      el('label', { class: 'gkg-field' }, [el('span', { class: 'gkg-label', text: T.gender }), genderRow]),
      channels,
      el('p', { class: 'gkg-note gkg-note--muted', text: T.dataNote })
    ], [el('button', { class: 'gkg-link', type: 'button', onclick: function () { self.renderEntry(); } }, ['← ' + T.phone])]);
  };

  // ---- Code anfordern ----
  GkgAuth.prototype.requestCode = function (channel) {
    var self = this; self.state.channel = channel; self.msg(''); self.busy(true);
    api('/auth/request-code', { body: { phone: self.state.phone, channel: channel, purpose: self.state.purpose } }).then(function (r) {
      self.busy(false);
      if (r.json.ok) { self.state.devCode = r.json.dev_code || null; return self.showCodeStep(); }
      self.msg(errText(r.json.error));
    });
  };

  // ---- Code eingeben ----
  GkgAuth.prototype.showCodeStep = function () {
    var self = this;
    var input = el('input', { class: 'gkg-input gkg-input--code', type: 'text', inputmode: 'numeric',
      autocomplete: 'one-time-code', maxlength: '6', placeholder: '••••••' });
    input.addEventListener('input', function () { input.value = digits(input.value).slice(0, 6); });
    var hint = el('p', { class: 'gkg-hint', text: self.state.channel === 'sms' ? T.codeSentSms : T.codeSentWa });
    var confirm = el('button', { class: 'gkg-btn', type: 'button', onclick: function () { self.submitCode(input.value); } }, [T.confirm]);
    var resend = el('button', { class: 'gkg-link', type: 'button', disabled: 'disabled' }, [T.resend]);
    var other = el('button', { class: 'gkg-link', type: 'button', onclick: function () {
      var ch = self.state.channel === 'whatsapp' ? 'sms' : 'whatsapp';
      if (ch === 'sms' && (!self.smsEnabled || !self.state.isKG)) return self.msg(errText('sms_kg_only'));
      if (self._iv) clearInterval(self._iv); self.requestCode(ch);
    } }, [T.tryOtherChannel]);
    var t = 60; resend.textContent = T.resendIn + ' ' + t + ' ' + T.sec;
    self._iv = setInterval(function () {
      t--; if (t <= 0) { clearInterval(self._iv); resend.disabled = false; resend.textContent = T.resend; }
      else resend.textContent = T.resendIn + ' ' + t + ' ' + T.sec;
    }, 1000);
    resend.addEventListener('click', function () { if (!resend.disabled) { clearInterval(self._iv); self.requestCode(self.state.channel); } });

    var nodes = [];
    if (self.state.devCode) nodes.push(el('div', { html: 'Тестовый код: <b>' + self.state.devCode + '</b>',
      style: 'background:#fff8e1;border:1px solid #ffe082;border-radius:8px;padding:.6rem;margin-bottom:.9rem;text-align:center;' }));
    // „Anderen Weg" nur zeigen, wenn wirklich ein zweiter Kanal verfügbar ist (SMS = nur +996).
    var canOther = self.smsEnabled && self.state.isKG;
    nodes.push(hint, input, confirm, el('div', { class: 'gkg-links' }, canOther ? [resend, other] : [resend]));
    self.card(T.enterCode, nodes);
  };

  // Nach erfolgreicher Anmeldung: Browser-Favoriten ins Konto übernehmen, dann weiter.
  GkgAuth.prototype.finishLogin = function (token) {
    var self = this; setSession(token);
    var p = (window.GkgFav && window.GkgFav.mergeAfterLogin) ? window.GkgFav.mergeAfterLogin() : Promise.resolve();
    var go = function () { self.go(self.urls.account); };
    p.then(go, go);
  };

  GkgAuth.prototype.submitCode = function (code) {
    var self = this; self.msg(''); self.busy(true);
    if (self.state.purpose === 'login') {
      api('/auth/verify', { body: { phone: self.state.phone, code: code } }).then(function (r) {
        self.busy(false);
        if (r.json.ok) return self.finishLogin(r.json.session_token);
        self.msg(errText(r.json.error));
      });
    } else {
      var body = { phone: self.state.phone, code: code };
      Object.keys(self.state.regData || {}).forEach(function (k) { body[k] = self.state.regData[k]; });
      api('/auth/register', { body: body }).then(function (r) {
        self.busy(false);
        if (r.json.ok) return self.finishLogin(r.json.session_token);
        self.msg(errText(r.json.error));
      });
    }
  };

  // ---- Konto (Layout nach Shopify-Kundenkonto: Titel + Выйти oben, zweispaltig Käufe/Daten) ----
  GkgAuth.prototype.accountShell = function (children) {
    this.root.innerHTML = '';
    this.root.appendChild(el('div', { class: 'gkg-acc' }, children));
  };
  GkgAuth.prototype.renderAccount = function () {
    var self = this;
    if (!getSession()) return self.go(self.urls.login);
    self.accountShell([el('h1', { class: 'gkg-acc__title', text: T.account }), el('p', { class: 'gkg-hint', text: '…' })]);
    // Profil sofort anzeigen; Bonuspunkte (Billz, langsamer) danach nachladen
    api('/me?loyalty=0', { auth: true }).then(function (r) {
      if (r.status === 401 || !r.json.ok) {
        clearSession(); if (window.GkgFav && window.GkgFav.clearLocal) window.GkgFav.clearLocal(); // geteiltes Gerät: Liste nicht liegen lassen
        return self.go(self.urls.login);
      }
      var u = r.json, name = [u.first_name, u.last_name].filter(Boolean).join(' ');
      var logout = el('button', { class: 'gkg-acc__logout', type: 'button', onclick: function () {
        clearSession(); if (window.GkgFav && window.GkgFav.clearLocal) window.GkgFav.clearLocal(); self.go(self.urls.login);
      } }, [T.logout]);
      // Hero-Banner (Zalando-Stil): Bild rechts, links Titel + Punkte-Pille + Gruß.
      // Pille grün, sobald Punkte > 0; Bild kommt aus dem Theme-Editor (data-banner).
      var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 3l2.7 5.8 6.3.7-4.7 4.3 1.3 6.2L12 16.9 6.4 20l1.3-6.2L3 9.5l6.3-.7z"/></svg>';
      var greetName = u.first_name || name;
      var ptsNum = el('span', { class: 'gkg-acc__pts-num', text: '…' });
      var ptsPill = el('span', { class: 'gkg-acc__pts', title: T.bonusHint });
      ptsPill.innerHTML = STAR; ptsPill.appendChild(ptsNum);
      api('/me/loyalty', { auth: true }).then(function (p) {
        var v = (p.json && p.json.ok) ? p.json.loyalty_points : null;
        ptsNum.textContent = (v == null ? '—' : String(v));
        if (v != null && Number(v) > 0) ptsPill.classList.add('gkg-acc__pts--active');
      });
      var hero = el('div', { class: 'gkg-acc__hero' });
      var bannerUrl = self.root.getAttribute('data-banner') || '';
      if (bannerUrl) {
        var heroImg = el('img', { class: 'gkg-acc__hero-img', alt: '' });
        heroImg.src = bannerUrl; heroImg.loading = 'eager';
        hero.appendChild(heroImg);
      }
      hero.appendChild(el('div', { class: 'gkg-acc__hero-inner' }, [
        el('div', { class: 'gkg-acc__hero-row' }, [el('h1', { class: 'gkg-acc__title', text: T.account }), ptsPill]),
        el('p', { class: 'gkg-acc__hero-greet', text: T.welcome + (greetName ? ', ' + greetName : '') + '!' }),
        el('p', { class: 'gkg-acc__hero-hint', text: T.bonusHint })
      ]));
      hero.appendChild(logout);
      var favCount = (window.GkgFav && window.GkgFav.load) ? window.GkgFav.load().length : 0;
      var favUrl = self.root.getAttribute('data-favorites-url') || '/pages/izbrannoe';
      function fmtDate(d) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(d || '')); return m ? (m[3] + '.' + m[2] + '.' + m[1]) : ''; }
      function ordPrice(n) { return String(n || 0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' KGS'; }
      // Eine Kaufposition. Fall 1 (in Shopify, aktiv): Live-Bild + Titel + Link ueber den Handle.
      // Fall 2 (nur Billz / inaktiv): sauberer Name + Preis/Datum, Platzhalter-Bild. Nie SKU.
      function orderCard(it) {
        var ph = el('span', { class: 'gkg-acc__ord-img gkg-acc__ord-img--ph' });
        var nameEl = el('span', { class: 'gkg-acc__ord-name', text: it.label || '' });
        var head = el('div', { class: 'gkg-acc__ord-head' }, [nameEl]);
        if (it.returned) head.appendChild(el('span', { class: 'gkg-acc__ord-badge', text: T.returned }));
        var meta = [];
        if (it.size) meta.push(T.sizeShort + ' ' + it.size);
        if (it.date) meta.push(fmtDate(it.date));
        if (it.shop) meta.push(it.shop);
        var body = el('div', { class: 'gkg-acc__ord-body' }, [
          head,
          el('div', { class: 'gkg-acc__ord-meta', text: meta.join(' · ') }),
          el('span', { class: 'gkg-acc__ord-price', text: ordPrice(it.total) })
        ]);
        var linkable = !!(it.in_shopify && it.active && it.handle);
        var card = el(linkable ? 'a' : 'div', linkable
          ? { class: 'gkg-acc__ord', href: '/products/' + encodeURIComponent(it.handle) }
          : { class: 'gkg-acc__ord gkg-acc__ord--nolink' }, [ph, body]);
        if (linkable) {
          fetch('/products/' + encodeURIComponent(it.handle) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
            .then(function (p) {
              if (!p) return;
              if (p.title) nameEl.textContent = p.title;
              if (p.featured_image) {
                var im = document.createElement('img');
                im.className = 'gkg-acc__ord-img'; im.loading = 'lazy'; im.alt = p.title || '';
                im.src = String(p.featured_image).replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1$2');
                if (ph.parentNode) ph.parentNode.replaceChild(im, ph);
              }
            });
        }
        return card;
      }
      var ordersBody = el('div', { class: 'gkg-acc__orders' }, [el('p', { class: 'gkg-acc__muted', text: T.ordersLoading })]);
      var orders = el('section', { class: 'gkg-acc__panel' }, [
        el('h2', { class: 'gkg-acc__h2', text: T.orderHistory }),
        ordersBody
      ]);
      api('/orders', { auth: true }).then(function (r) {
        ordersBody.innerHTML = '';
        var items = (r.json && r.json.ok && r.json.orders) || [];
        if (!items.length) {
          ordersBody.appendChild(el('p', { class: 'gkg-acc__muted', text: (r.json && r.json.ready) ? T.ordersEmpty : T.ordersLoading }));
          return;
        }
        items.forEach(function (it) { ordersBody.appendChild(orderCard(it)); });
      });
      // Мои данные: Ansicht + Editier-Modus (Name/Geburtsdatum/Geschlecht; Nummer NIE — Login-Schlüssel)
      var profile = { first_name: u.first_name || '', last_name: u.last_name || '', birth_date: u.birth_date || '', gender: u.gender || '' };
      var details = el('section', { class: 'gkg-acc__panel' });
      function detailsView(savedMsg) {
        details.innerHTML = '';
        var pname = [profile.first_name, profile.last_name].filter(Boolean).join(' ');
        var pgender = profile.gender === 'MALE' ? T.genderMale : (profile.gender === 'FEMALE' ? T.genderFemale : '');
        var pbirth = fmtDate(profile.birth_date);
        details.appendChild(el('div', { class: 'gkg-acc__favs-head' }, [
          el('h2', { class: 'gkg-acc__h2', text: T.accountDetails }),
          el('button', { class: 'gkg-acc__editlink', type: 'button', text: T.edit, onclick: function () { detailsEdit(); } })
        ]));
        if (savedMsg) details.appendChild(el('p', { class: 'gkg-msg gkg-msg--ok', text: savedMsg }));
        if (pname) details.appendChild(el('div', { class: 'gkg-row' }, [el('span', { text: T.nameLabel }), el('strong', { text: pname })]));
        details.appendChild(el('div', { class: 'gkg-row' }, [el('span', { text: T.yourPhone }), el('strong', { text: u.phone })]));
        if (pbirth) details.appendChild(el('div', { class: 'gkg-row' }, [el('span', { text: T.birthLabel }), el('strong', { text: pbirth })]));
        if (pgender) details.appendChild(el('div', { class: 'gkg-row' }, [el('span', { text: T.genderLabel }), el('strong', { text: pgender })]));
      }
      function detailsEdit() {
        details.innerHTML = '';
        var msg = el('p', { class: 'gkg-msg' });
        var fn = el('input', { class: 'gkg-input', type: 'text', maxlength: '40', autocomplete: 'given-name' }); fn.value = profile.first_name;
        var ln = el('input', { class: 'gkg-input', type: 'text', maxlength: '40', autocomplete: 'family-name' }); ln.value = profile.last_name;
        var bd = el('input', { class: 'gkg-input', type: 'date' }); bd.value = profile.birth_date;
        var g = profile.gender, segM, segF;
        function segSel(v) { g = v; segM.classList.toggle('gkg-seg--on', v === 'MALE'); segF.classList.toggle('gkg-seg--on', v === 'FEMALE'); }
        segM = el('button', { class: 'gkg-seg', type: 'button', text: T.genderMale, onclick: function () { segSel('MALE'); } });
        segF = el('button', { class: 'gkg-seg', type: 'button', text: T.genderFemale, onclick: function () { segSel('FEMALE'); } });
        segSel(g);
        var save = el('button', { class: 'gkg-btn', type: 'button', text: T.save });
        save.addEventListener('click', function () {
          save.disabled = true;
          api('/me/update', { auth: true, body: { first_name: fn.value, last_name: ln.value, birth_date: bd.value, gender: g } }).then(function (r) {
            save.disabled = false;
            if (r.json && r.json.ok) {
              profile = { first_name: r.json.first_name, last_name: r.json.last_name, birth_date: r.json.birth_date, gender: r.json.gender };
              detailsView(T.saved);
            } else {
              msg.textContent = errText(r.json && r.json.error); msg.className = 'gkg-msg gkg-msg--error';
            }
          });
        });
        var cancel = el('button', { class: 'gkg-btn gkg-btn--ghost', type: 'button', text: T.cancel, onclick: function () { detailsView(); } });
        details.appendChild(el('div', { class: 'gkg-acc__favs-head' }, [el('h2', { class: 'gkg-acc__h2', text: T.accountDetails })]));
        details.appendChild(el('div', { class: 'gkg-acc__editwrap' }, [
          msg,
          self.labeled(T.firstName, fn),
          self.labeled(T.lastName, ln),
          self.labeled(T.birthLabel, bd),
          el('label', { class: 'gkg-field' }, [el('span', { class: 'gkg-label', text: T.genderLabel }), el('div', { class: 'gkg-seg-row' }, [segM, segF])]),
          el('div', { class: 'gkg-acc__edit-actions' }, [save, cancel])
        ]));
      }
      detailsView();
      // Kachel-Knöpfe: Мои покупки / Мои данные (umschaltbar) + Избранное (Link zur Merkliste)
      var ICON_BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M6.5 8V7a5.5 5.5 0 0111 0v1h2.8l-1.1 12.5H4.8L3.7 8h2.8zm2 0h7V7a3.5 3.5 0 10-7 0v1z"/></svg>';
      var ICON_USER = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M12 11.5a4 4 0 100-8 4 4 0 000 8zm-7.5 9c.6-3.5 3.6-5.5 7.5-5.5s6.9 2 7.5 5.5z"/></svg>';
      var ICON_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
      // Favoriten-Vorschau: die ersten 4 gemerkten Modelle (Bild/Titel/Preis) direkt im Konto
      var favItems = (window.GkgFav && window.GkgFav.load) ? window.GkgFav.load() : [];
      function kgs(cents) { var n = Math.round(cents / 100); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' KGS'; }
      var favGrid = el('div', { class: 'gkg-acc__favgrid' });
      favItems.slice(0, 8).forEach(function (it) {
        var url = '/products/' + encodeURIComponent(it.handle);
        var img = el('span', { class: 'gkg-acc__fav-img' });
        var priceEl = el('span', { class: 'gkg-acc__fav-price', text: '' });
        var card = el('a', { class: 'gkg-acc__fav', href: url }, [img,
          el('span', { class: 'gkg-acc__fav-body' }, [el('span', { class: 'gkg-acc__fav-name', text: it.title || it.handle }), priceEl])]);
        favGrid.appendChild(card);
        fetch('/products/' + encodeURIComponent(it.handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
          .then(function (p) {
            if (!p) return;
            if (p.title) card.querySelector('.gkg-acc__fav-name').textContent = p.title;
            if (p.featured_image) {
              var im = document.createElement('img');
              im.className = 'gkg-acc__fav-img'; im.loading = 'lazy'; im.alt = p.title || '';
              im.src = String(p.featured_image).replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1$2');
              card.replaceChild(im, img);
            }
            if (p.price != null) priceEl.textContent = kgs(p.price);
          });
      });
      // Mobil wird das Raster zum Wisch-Slider; Abschlusskarte (nur Text, Bildhöhe) führt zur Merkliste
      if (favCount) {
        favGrid.appendChild(el('a', { class: 'gkg-acc__fav gkg-acc__fav--all', href: favUrl }, [
          el('span', { class: 'gkg-acc__fav-alltext', text: T.seeAll })
        ]));
      }
      var favsPanel = el('section', { class: 'gkg-acc__panel gkg-acc__panel--flat' }, [
        el('div', { class: 'gkg-acc__favs-head' }, [
          el('h2', { class: 'gkg-acc__h2', text: T.favsTile + (favCount ? ' (' + favCount + ')' : '') }),
          favCount ? el('a', { class: 'gkg-link', href: favUrl, text: T.seeAll }) : null
        ].filter(Boolean)),
        favCount ? favGrid : el('p', { class: 'gkg-acc__muted', text: T.favsEmptyAcc })
      ]);
      var tileOrders, tileDetails, tileFav;
      function show(key) {
        orders.hidden = key !== 'orders';
        details.hidden = key !== 'details';
        favsPanel.hidden = key !== 'favs';
        tileOrders.classList.toggle('gkg-acc__tile--on', key === 'orders');
        tileDetails.classList.toggle('gkg-acc__tile--on', key === 'details');
        tileFav.classList.toggle('gkg-acc__tile--on', key === 'favs');
      }
      function tile(label, icon, onclick) {
        var b = el('button', { class: 'gkg-acc__tile', type: 'button', onclick: onclick });
        b.innerHTML = icon; b.appendChild(el('span', { text: label }));
        return b;
      }
      tileOrders = tile(T.myPurchases, ICON_BAG, function () { show('orders'); });
      tileDetails = tile(T.myData, ICON_USER, function () { show('details'); });
      tileFav = tile(T.favsTile + (favCount ? ' (' + favCount + ')' : ''), ICON_HEART, function () { show('favs'); });
      self.accountShell([
        hero,
        el('div', { class: 'gkg-acc__tiles' }, [tileFav, tileOrders, tileDetails]),
        el('div', { class: 'gkg-acc__content' }, [favsPanel, details, orders]),
        (function () { // Serviceteam-Kontakt (WhatsApp) unten im Konto
          var a = el('a', { class: 'gkg-acc__support-btn', target: '_blank', rel: 'noopener',
            href: 'https://wa.me/996990305090?text=' + encodeURIComponent(T.supportMsg) });
          a.innerHTML = '<svg viewBox="0 0 448 512" aria-hidden="true" focusable="false"><path fill="currentColor" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.2-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>';
          a.appendChild(el('span', { text: T.supportBtn }));
          return el('div', { class: 'gkg-acc__support' }, [a]);
        })()
      ]);
      show('orders');
    });
  };

  function init() { var r = document.querySelectorAll('[data-gkg-auth]'); for (var i = 0; i < r.length; i++) new GkgAuth(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
